import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetOffersCargoSubscriptionsParams } from "../model";

export const useGetOffersCargoSubscriptions = (
  params: GetOffersCargoSubscriptionsParams,
  options?: QueryOptions<typeof FreightMatching.useGetOffersCargoSubscriptions>,
): UseQueryResult<
  FreightMatching.GetOffersCargoSubscriptionsQueryResult,
  undefined
> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getOffersCargoSubscriptions", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getOffersCargoSubscriptions(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetOffersCargoSubscriptionsQueryResult,
    undefined
  >;
};

export const useMultipleGetOffersCargoSubscriptions = (
  paramsList: { [key: string | number]: GetOffersCargoSubscriptionsParams },
  options?: QueryOptions<
    typeof FreightMatching.useGetOffersCargoSubscriptions
  > & {
    sortFunc?: (
      a: GetOffersCargoSubscriptionsParams,
      b: GetOffersCargoSubscriptionsParams,
    ) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetOffersCargoSubscriptionsQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getOffersCargoSubscriptions", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getOffersCargoSubscriptions(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetOffersCargoSubscriptionsQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetOffersCargoSubscriptionsMock = (
//   params: GetOffersCargoSubscriptionsParams,
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargoSubscriptions>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargoSubscriptionsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetOffersCargoSubscriptions(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetOffersCargoSubscriptionsMock = (
//   paramsList: { [key: string | number]: GetOffersCargoSubscriptionsParams },
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargoSubscriptions>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargoSubscriptionsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetOffersCargoSubscriptions(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
